import { useState, useEffect } from 'react'
import { authenticate, getAccessToken, loginWithRedirect, logout } from '../auth'

export default function useAuth() {
  const [user, setUser] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const auth = async () => {
    if (window.location.pathname !== '/auth') {
      await getAccessToken()
    }
    // Read user AFTER refresh so we get the updated data
    const storedUser = JSON.parse(localStorage.getItem('user'))
    setUser(storedUser)
    setIsAuthenticated(Boolean(storedUser))
    setIsLoading(false)
  }

  useEffect(() => {
    auth()
  }, [])

  return {
    isAuthenticated,
    user,
    getAccessTokenSilently: async () => getAccessToken(),
    loginWithRedirect,
    loginWithPopup: () => {},
    logout,
    isLoading
  }
}
